import { MobileNavigationComponent, MobileNavigationProps } from './MobileNavigation';
import { getNavDestinations, getNavOffers, getNavInfo } from '@state/cms';
import { useSelector } from 'react-redux';
import { dispatch } from '@state/store';
import { useTheme } from '@emotion/react';
import { getIsAgent } from '@state/slices/agent/agentSelectors';
import { logoutAgent } from '@state/slices/agent/agentSlice';

export interface MobileNavigationContainerProps {
  testId?: string;
  open: boolean;
  onDismiss: () => void;
}

export const MobileNavigationContainer = (ownProps: MobileNavigationContainerProps) => {
  const props: MobileNavigationProps = {
    theme: useTheme(),
    navDestinations: useSelector(getNavDestinations),
    navOffers: useSelector(getNavOffers),
    navInfo: useSelector(getNavInfo),
    isAgent: useSelector(getIsAgent),
    onLogout: () => dispatch(logoutAgent()),
    ...ownProps
  };

  return <MobileNavigationComponent {...props} />;
};
